import type TreeNode from "./TreeNode.ts";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import htmx from "htmx.org";

export default class ExplorerMode extends AlpineComponent {
  constructor() {
    super();
  }

  init() {
    (window as any)["explorer"] = this;
  }

  onSelect(event: CustomEvent<{ value: string }>) {
    htmx.ajax("get", event.detail.value, {});
  }

  onTreeNodeOpened(event: CustomEvent<TreeNode>) {
    const url = event.detail.openUrl;
    if (!url) return;
    htmx.ajax("get", url, {});
  }

  onTreeNodeClosed(event: CustomEvent<TreeNode>) {
    const url = event.detail.closeUrl;
    if (!url) return;
    htmx.ajax("get", url, {});
  }
}
